// Smooth-scroll helpers for the landing page's in-page navigation.
//
// Anchors call these with preventDefault instead of letting the browser write
// `#section` into the URL — a hash in the URL makes a later refresh re-anchor
// mid-page instead of loading at the top. (Arriving from an external link
// that DOES carry a hash is still handled by LandingPage's one-shot effect.)

function reducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function scrollToSection(hash: string): void {
  document.querySelector(hash)?.scrollIntoView({
    behavior: reducedMotion() ? "auto" : "smooth",
  });
}

export function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: reducedMotion() ? "auto" : "smooth" });
}
